module.exports = __webpack_public_path__ + "static/ext2-75e2ab4c742bd02159e61de4addb4444.png";